import { fetchUtil } from "@/libs/fetch";
import { NEXT_PUBLIC_GATEWAY_API_DOMAIN } from "@/libs/constants/auth";
import { FiltersApiResponse, ResourceListingApiResponse } from "@/components/PageAllResources/api/interface";

export const fetchAllResourceFiltersAPI: (payload?: any, pageUrl?: string) => Promise<FiltersApiResponse> = async (
  payload,
  pageUrl
) => {
  return fetchUtil({
    url: `${NEXT_PUBLIC_GATEWAY_API_DOMAIN}/mom-baby/getFiltersParams`,
    method: "POST",
    body: payload,
    useToken: false,
    pageUrl,
  });
};

export const fetchAllResourceAPI: (payload: any, pageUrl?: string) => Promise<ResourceListingApiResponse> = async (
  { page = 1, limit = 10, ...rest },
  pageUrl
) => {
  const payload = {
    ...rest,
    pagination: {
      pageNo: page,
      pageSize: limit,
    },
  };

  return fetchUtil({
    url: `${NEXT_PUBLIC_GATEWAY_API_DOMAIN}/mom-baby/resourceListing`,
    method: "POST",
    body: payload,
    useToken: false,
    pageUrl,
  });
};
